import React from 'react'
import Navbar from '../components/maketApp/site/Navbar'

import Footer from '../components/maketApp/site/Footer'
import Contact from '../components/maketApp/site/Contact'
import { useParams } from 'react-router-dom'

import FormationDetail from '../components/maketApp/site/FormationDetail'

const FormationDetailPage = () => {
    const { titre, id } = useParams();

  return (
    <div>
       <Navbar />
   

        <FormationDetail formationId={id}  titre={titre} onSuccess={(result) => {
        console.log('Candidature créée, ID :', result.candidatureId);
      }} />
 
         <Footer />
    </div>
  )
}

export default FormationDetailPage
